var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpload3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 50,
    viewBox: "0 0 40 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 0H5C2.25 0 0.0250006 2.25 0.0250006 5L0 45C0 47.75 2.225 50 4.975 50H35C37.75 50 40 47.75 40 45V15L25 0ZM35 45H5V5H22.5V17.5H35V45ZM10 32.525L13.525 36.05L17.5 32.1V42.5H22.5V32.1L26.475 36.075L30 32.525L20.025 22.5L10 32.525Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload3);
export default __webpack_public_path__ + "static/media/upload3.c869e8ac9002fc31c924eb5ed31a840a.svg";
export { ForwardRef as ReactComponent };